export default "__VITE_ASSET__d869d091__"